import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Mixpanel from "mixpanel-browser";
import { CREATED } from "../../../constants/statusCode";
import { addProject } from "../../../features/projectManagement/addProjectSlice";
import { getProjectList } from "../../../features/projectManagement/getProjectListSlice";
import Button from "../../form-components/Button";
import Input from "../../form-components/Input";
import Loader from "../../../common/loader/Loader";
import { getSwitchProjectList } from "../../../features/projectManagement/switchProjectSlice";

const AddProjectModal = ({ isVisible, toggleFunction }) => {

  const { addProjectLoading } = useSelector((state) => ({
    addProjectLoading: state?.addProjectReducer?.isLoading
  }));

  const [shortName, setShortName] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [shortNameError, setShortNameError] = useState("");
  const [website_urlError, setWebsite_urlError] = useState("");
  const regex = /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/
  const dispatch = useDispatch();

  let projectData = JSON.parse(localStorage.getItem("_user"));

  const addNewProject = async () => {
    if (!shortName) {
      setShortNameError("Please enter project name");
    } else {
      if (shortName && websiteUrl && !regex.test(websiteUrl)) {
        setWebsite_urlError("Invalid URL");
      } else if (!website_urlError) {
        let formData = {};
        formData.name = shortName;
        formData.website_url = websiteUrl;
        formData.project_uuid = projectData?.projects[0]?.uuid;
        formData.organization_uuid = projectData?.organizations[0]?.uuid;
        Mixpanel.track("Add project Button Clicked", {
          Page: "Add Project Modal",
        });
        const { payload } = await dispatch(addProject(formData));
        if (payload.status === CREATED) {
          toggleFunction();
          dispatch(getProjectList({ perPage: 10, page: 1 }));
          dispatch(getSwitchProjectList({ search: "" }));
        }
      }
    }
  };

  return (
    <>
      {addProjectLoading ? <Loader />
        :
        <Modal
          data-bs-keyboard="false"
          onHide={toggleFunction}
          show={isVisible}
          className="modal fade editproject-popup"
          centered={true}
          dialogClassName="common-modal"
        >
          <ModalHeader closeButton onHide={toggleFunction}>
            <h3 className="modal-title" id="Add_OrganizationLabel">
              Add Project
            </h3>
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-label">Project Short Name*</label>
                    <Input
                      type="text"
                      placeholder="Project Short Name"
                      className="form-control"
                      onChange={(e) => {
                        setShortName(e.target.value);
                        setShortNameError("");
                      }}
                    />
                    <span className="text-danger">{shortNameError}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <div className="form-group">
                    <label className="form-label">Website URL</label>
                    <Input
                      type="text"
                      placeholder="Website URL"
                      className="form-control"
                      onChange={(e) => {
                        setWebsiteUrl(e.target.value);
                        setWebsite_urlError("");
                      }}
                    />
                    <span className="text-danger">{website_urlError}</span>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="btn btn-primary-md"
              onClick={() => addNewProject()}
            >
              Save
            </Button>
          </ModalFooter>
        </Modal>
      }
    </>
  );
};

export default AddProjectModal;
